import React, {useEffect, useState} from "react";
import {changePageSizeState} from "../../../Slices/PageSlice";
import PageSizeState from "../../../Constants/Base/PageSizeState";
import {useDispatch} from "react-redux";
import {deleteInventoryType, getInventoryTypeList} from "../../../Services/AssetManagement/InventoryTypeService";
import TablePage from "../../../Components/DataGrid/TablePage";
import strings from "../../../localization";
import {formatColumnObject} from "../../../Components/DataGrid/ValueFormatter";
import {changeBreadcrumbs} from "../../../Slices/BreadcrumbsSlice";
import Modules from "../../../Constants/Base/Modules";
import AddInventoryType from "./AddInventoryType";
import TablePageContext, {
    FilterDefaults,
    TableDataDefaults,
    TablePageOptionDefaults
} from "../../../Context/TablePageContext";
import { returnColumnBoolean } from "../../../Components/DataGrid/ValueCellRender";
import PageState from "../../../Constants/Base/PageState";
import EditInventoryType from "./EditInventoryType";
import ReferenceType from "../../../Constants/DocumentManagement/ReferenceType";
import { useNavigate, useSearchParams } from "react-router-dom";
import AppPermissions from "../../../Constants/Permissions/Permissions";
import Tag from "../../../Components/Forms/Pages/Document/Tag/Tag";

const tableDescription = [
    {
        field: 'name', headerName: strings.pages.assetManagement.inventoryType.inventoryTypeList.name,
        width: 200,
    },
    {
        field: 'description', headerName: strings.pages.assetManagement.inventoryType.inventoryTypeList.description,
        width: 300,
    },
    {
        field: 'canReturnTax', headerName: strings.pages.assetManagement.inventoryType.inventoryTypeList.canReturnTax,
        width: 150,
        renderCell: (params) => returnColumnBoolean(params)
    },
    {
        field: 'category',
        headerName: strings.pages.assetManagement.inventoryType.inventoryTypeList.category,
        valueFormatter: (params) => formatColumnObject(params, 'name'),
        width: 250
    }
];

const filters = []

const InventoryTypeList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [updatedFilter, setUpdatedFilter] = useState(!Boolean(searchParams.toString()));
    const [columns, setColumns] = useState([]);
    const [pageState, setPageState] = useState(PageState.View);
    const [filter, setFilter] = useState(FilterDefaults);
    const [tableData, setTableData] = useState(TableDataDefaults);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [selectionModel, setSelectionModel] = useState([]);
    const [selectedItems, setSelectedItems] = useState(null);
    const [tablePageOptions, setTablePageOptions] = useState(TablePageOptionDefaults);
    const referenceType = ReferenceType.INVETORY_TYPE;
    const permissionGroup = AppPermissions.INVENTORY_TYPE.GROUP;

    const value = {
        tablePageOptions, setTablePageOptions,
        selectionModel, setSelectionModel,
        selectedItems, setSelectedItems,
        filter, setFilter, pageState, setPageState, showDeleteDialog, setShowDeleteDialog,
        navigate, updatedFilter, setUpdatedFilter
    }

    useEffect(() => {
        setColumns([...tableDescription]);
        dispatch(changePageSizeState(PageSizeState.SHORT));
        dispatch(changeBreadcrumbs({
            title: strings.pages.assetManagement.inventoryType.inventoryTypeList.pageTitle,
            hierarchy:[
                {label: strings.navigation.managmentTag},
                {label: Modules.ASSETS},
                {label: strings.pages.assetManagement.inventoryType.inventoryTypeList.pageTitle}
            ],        
        }));

        return () => {
            setTableData({})
        }
    }, [])

    useEffect(() => {
        if(!updatedFilter){
            return;
        }

        fetch();
    }, [filter, updatedFilter]);
    

    const onCancel = () => {
        setPageState(PageState.View);
    }

    const onFinish = () => {
        fetch();
        setPageState(PageState.View);
    }

    const fetch = () => {
        setTableData({
            ...tableData,
            loading: true
        });

        getInventoryTypeList({
            ...filter
        }).then(response => {

            if (!response || !response.ok) {
                return;
            }

            setTableData({
                loading: false,
                data: response.data.result,
                total: response.data.total
            });
        })
    }

    return <TablePageContext.Provider value={value}>
        <TablePage onFinish={() => onFinish()} deleteItem={deleteInventoryType} tableDescription={columns}
                   tableData={tableData} filter={filter} filters={filters}
                   referenceType={referenceType} permissionGroup={permissionGroup}
                   tagPage={<Tag referenceType={ referenceType } data={ selectedItems } /> }
                   editPage={<EditInventoryType data={ selectedItems }
                   onCancel={() => onCancel()} onFinish={() => onFinish()}/>}
                   addPage={<AddInventoryType onCancel={() => onCancel()} onFinish={() => onFinish()}/>}
                   addButtonText={strings.components.tablePage.addButton.inventoryType}
                   />
    </TablePageContext.Provider>;
}

export default InventoryTypeList;
